module.exports = __webpack_public_path__ + "img/Girl_030028.30abb317.png";